import { useLayoutEffect, useState } from 'react';
import cx from 'classnames';
import ThreadTag, { ThreadTagType } from '../ThreadTag/mIndex';
import Styles from './mIndex.module.scss';

export interface IThreadTitle {
  className?: string;
  title: string;
  tags?: ThreadTagType[];
  lines?: number;
  isShowToolTip?: boolean;
}

const ThreadTitle = ({
  className = '',
  title,
  tags = [],
  lines,
  isShowToolTip = false,
}: IThreadTitle) => {
  const [formatTitle, setFormatTitle] = useState('');

  // 在ThreadTitle组件中，formatTitle的值是在useLayoutEffect中设置的
  // 但这个useLayoutEffect的依赖数组是空的[]
  // 这意味着它只会在组件第一次挂载时执行，而不会在title属性改变时更新
  // 将title添加到useLayoutEffect的依赖数组中 当title变化时会重新执行该副作用
  useLayoutEffect(() => {
    if (!title) {
      setFormatTitle('');
    } else {
      let temp: HTMLDivElement | null = document.createElement("div");
      temp.innerHTML = title;
      setFormatTitle(temp.textContent || temp.innerText);
      temp = null;
    }
  }, [title])

  return (
    <div 
      className={cx(Styles.root, {"tooltip tooltipTop" : isShowToolTip})}
      data-tooltip={formatTitle}
    >
      <div className={cx(Styles.title, className)} style={{WebkitLineClamp: lines ? lines : 1}}>
        {
          tags.length > 0 && tags.map((tag) => <ThreadTag key={tag} className={Styles.tag} type={tag} />
          )
        }
        <span className={cx({[Styles.text]: tags.length > 0})}>{formatTitle}</span>
      </div>
    </div>
  );
};

export default ThreadTitle;
